
const PrimaryGamesItems = [
  "ア．個人種目 ボール コンタクト",
  "イ．個人種目 ボール 非コンタクト",
  "ウ．個人種目 非ボール コンタクト",
  "エ．個人種目 非ボール 非コンタクト",
  "カ．団体種目 ボール コンタクト",
  "キ．団体種目 ボール 非コンタクト",
  "ク．団体種目 非ボール コンタクト",
  "ケ．団体種目 非ボール 非コンタクト",
  "サ．障がい者スポーツ"
  ];

export default PrimaryGamesItems;
